/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card, CardContent, Grid, Typography,
} from '@material-ui/core';
import { numGradeToEUgrade } from '../../../helpers/utils';

const useStyles = makeStyles((theme) => ({
  cardHeader: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFF',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
  },
  title: {
    fontWeight: 'bold',
    fontSize: '1.2rem',
  },
  cell: {
    textAlign: 'center',
    padding: theme.spacing(2, 1),
  },
  label: {
    display: 'block',
    marginBottom: theme.spacing(0.5),
  },
  grade: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
}));

const PlacementTestResultWidget = ({ scores }) => {
  const classes = useStyles();
  const items = [
    { label: 'Connaissances', value: scores.scoreKN },
    { label: 'Compréhension écrite', value: scores.scoreRC },
    { label: 'Compréhension orale', value: scores.scoreOC },
    { label: 'Note globale', value: scores.total },
  ];

  return (
    <Card style={{ width: '100%' }}>
      <div className={classes.cardHeader}>
        <Typography component="h2" variant="h5" className={classes.title}>
          Placement test results
        </Typography>
      </div>
      <CardContent style={{ paddingBottom: 16 }}>
        <Grid container spacing={1}>
          {items.map((row) => (
            <Grid item xs={12} sm={6} md={3} key={row.label}>
              <div className={classes.cell}>
                <Typography variant="body2" color="textSecondary" className={classes.label}>
                  {row.label}
                </Typography>
                <Typography variant="h5" component="p" className={classes.grade}>
                  {numGradeToEUgrade(row.value)}
                </Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

PlacementTestResultWidget.propTypes = {
  scores: PropTypes.shape({
    scoreKN: PropTypes.number,
    scoreRC: PropTypes.number,
    scoreOC: PropTypes.number,
    total: PropTypes.number,
  }).isRequired,
};

export default PlacementTestResultWidget;
